// the BackboneSwap Default token list lives here

export const DEFAULT_TOKEN_LIST_URL = 'https://raw.githubusercontent.com/BackboneSwap/token-list/main/backbonewap.tokenlist.json'

export const DEFAULT_LIST_OF_LISTS: string[] = [
  DEFAULT_TOKEN_LIST_URL
]
